import { Breadcrumb } from 'antd';
import { ComponentProps } from 'react';
import { createPortal } from 'react-dom';

function PageBreadcrumb(props: ComponentProps<typeof Breadcrumb>) {
  const container = document.querySelector('#breadcrumb')!;
  if (!container) return null;

  return createPortal(<Breadcrumb {...props} />, container);
}

export default PageBreadcrumb;
